import { AUDIENCE, EMAIL, SMS, REVIEW } from './constants';
import { Audience } from '../components/Audience.jsx';
import { Email } from '../components/Email.jsx';
import { Sms } from '../components/Sms.jsx';
import { Review } from '../components/Review.jsx';

export const STEPS = {
  audience: {
    name: 'Audience',
    id: AUDIENCE,
    component: Audience,
  },
  email: {
    name: 'Compose Email',
    id: EMAIL,
    component: Email,
  },
  sms: {
    name: 'Compose Text',
    id: SMS,
    component: Sms,
  },
  review: {
    name: 'Review',
    id: REVIEW,
    component: Review,
  },
};
